// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"38":"ErrorsList","603":"TagsView","780":"TagsCreate","924":"TagsEdit"}[chunkId] || chunkId) + "." + {"38":"666cbc4b","134":"a471cd60","160":"cbe91a6e","346":"f00cb313","603":"b9ce62d5","780":"cc5456d1","924":"3dee496f"}[chunkId] + ".chunk.js";
};